import updateIngredientsBannerStories from "./UpdateIngredientsBanner.stories";

const stories = {
  name: "ingredients",
  children: [updateIngredientsBannerStories],
};

export default stories;
